import { render } from "./SkeletonPlaylist.vue?vue&type=template&id=2c9eac66"
import script from "./SkeletonPlaylist.vue?vue&type=script&lang=js"
export * from "./SkeletonPlaylist.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__